// conversion tracking code provided by Ontario Reign
export default function (totalCharge) {
  fbq("track", "Purchase", {
    content_name: "Purchase",
    value: totalCharge,
    currency: "USD",
  });
}
